// extracted by mini-css-extract-plugin
export default {"placeholder":"styles_placeholder__yjHz7","isRounded":"styles_isRounded__Dgyqt"};